import { replaceSymbols } from '../../../helpers/replaceSymbols';
import { validateSettlement } from '../Validation';

import { InputField, InputFieldProps } from './InputField';

// There is places where we can also use SettlementField component, but there is not need in current validation (said BA)
// So do not add this component everywhere u want, ask BA firstly
export const SettlementField: React.FC<InputFieldProps> = ({ label = 'Назва населеного пункту', ...props }) => {
  return (
    <InputField
      {...props}
      label={label}
      change={(name, value): void => {
        const stringWithReplacedApostrophes = replaceSymbols(value ?? '', "'‘`׳᾿◌́ˈʼꞌי", "'");
        props.change(name, stringWithReplacedApostrophes);
      }}
      validator={validateSettlement}
    />
  );
};
